import { p as proxyCustomElement, H, h, c as Host } from './p-Dm99HnvB.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.5.0
 */

const SidenavResponsiveHeader = /*@__PURE__*/ proxyCustomElement(class SidenavResponsiveHeader extends H {
    constructor() {
        super();
        this.__registerHost();
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: '624a038cbc0781f42a91258c1a250719475f887e', class: "tds-sidenav-responsive-header" }, this.label && (h("h2", { key: '455fedabcabdac824e47ad264d6dfa51c33fc770', class: "tds-sidenav-responsive-header-label" }, this.label)), h("button", { key: '24c63296f5413840a62353ee2e4eb7d7e347dc87', type: "button", class: "tds-sidenav-responsive-header-toggle", "aria-label": "Menu", "aria-controls": this.popoverId, popoverTarget: this.popoverId }, h("svg", { key: '140b4aca347cd2e335ed7ec29d28d0352d2e4c01', xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, h("path", { key: '50ec3bc681d3ed6c5ef4c0f570ebeb675b508284', d: "M0 6.91104H16V8.68904H0V6.91104ZM0 13.133H16V11.356H0V13.133ZM0 2.46704V4.24404H16V2.46704H0Z", fill: "currentColor" })))));
    }
    get el() { return this; }
}, [2, "tds-sidenav-responsive-header", {
        "label": [1],
        "popoverId": [1, "popover-id"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav-responsive-header"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav-responsive-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SidenavResponsiveHeader);
            }
            break;
    } });
}

export { SidenavResponsiveHeader as S, defineCustomElement as d };
//# sourceMappingURL=p-DR8eykxK.js.map
